// Diálogo compartilhado "Reagendar próxima ação" — usado em DealDetalhe e
// ClienteDetalhe. Mudança 100% visual: as regras (quem pode reagendar,
// checagem de divergência de datas, PATCH no backend) ficam no caller.
import React from "react";
import { AppModal, AppModalPrimaryButton, AppModalSecondaryButton, APP_MODAL_TOKENS } from "@/components/ui/AppModal";
import { Loader2 } from "@/components/icons";

export default function ReagendarProximaDialog({
  open,
  onClose,
  value,
  onChange,
  onSalvar,
  saving = false,
  testId = "reag-proxima",
}) {
  const T = APP_MODAL_TOKENS;
  return (
    <AppModal
      open={open}
      onOpenChange={(o) => !o && onClose?.()}
      title="Reagendar próxima ação"
      size="sm"
      testId={testId}
      footer={(
        <>
          <AppModalSecondaryButton onClick={onClose} disabled={saving} data-testid={testId + "-cancelar"}>
            Cancelar
          </AppModalSecondaryButton>
          <AppModalPrimaryButton onClick={onSalvar} disabled={saving || !value} data-testid={testId + "-salvar"}>
            {saving ? <Loader2 style={{ width: 16, height: 16 }} className="animate-spin" /> : null}
            Salvar
          </AppModalPrimaryButton>
        </>
      )}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <label style={{ color: T.textSecondary, fontSize: 11, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600 }}>
          Nova data e hora
        </label>
        <input
          type="datetime-local"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          data-testid={testId + "-data"}
          style={{
            height: 44, padding: "0 12px",
            borderRadius: 8, border: "1px solid " + T.divider,
            fontSize: 14, color: T.text, outline: "none",
          }}
          autoFocus
        />
      </div>
    </AppModal>
  );
}
